import { combineReducers } from "redux";
import changeSideBarReducer from "./changeSideBarReducer";

export default combineReducers({
  changeSideBarReducer,
});
